// Mock data for Manthan's portfolio
// All user-provided real links and info live here so backend swap is trivial later.

export const profile = {
  name: "Manthan",
  fullName: "Manthan Dhotre",
  heading: "I'm Manthan.",
  subHeadline:
    "Finance Operations & Equity Researcher. Founder of 'Snippet of Startup'.",
  tagline: "Data-driven insights built on operational foundations.",
};

export const links = {
  linkedin: "https://www.linkedin.com/in/manthandhotre/",
  instagram: "https://www.instagram.com/manthandhotre17/",
  substack: "https://snippetofstartups.substack.com/",
  email: "manthandhotre17@gmail.com",
  bataReport:
    "https://drive.google.com/file/d/1lu7nj_XQ5GGzk5nXMRGV3294uqZFm20z/view?usp=sharing",
};

export const bentoWindows = [
  {
    id: "equity",
    title: "equity_research.pdf",
    label: "PRESENT",
    heading: "Bata India — Equity Research Report",
    body:
      "In-depth valuation and equity research conducted via Valuation School. A complete fundamental breakdown of Bata India Ltd.",
    ctaLabel: "Open Report",
    ctaHref:
      "https://drive.google.com/file/d/1lu7nj_XQ5GGzk5nXMRGV3294uqZFm20z/view?usp=sharing",
    meta: ["VALUATION", "FUNDAMENTALS", "FMCG"],
  },
  {
    id: "newsletter",
    title: "startup_newsletter.exe",
    label: "PRESENT",
    heading: "Snippet of Startup — Weekly Newsletter",
    body:
      "Analyzing Fintech & Quick Commerce ecosystems. Deep dives on unit economics, funding flows, and operator moves.",
    ctaLabel: "Read on Substack",
    ctaHref: "https://snippetofstartups.substack.com/",
    meta: ["FINTECH", "Q-COMMERCE", "FOUNDER"],
  },
  {
    id: "academic",
    title: "academic_status.sys",
    label: "PAST / FOUNDATION",
    heading: "Academic & Operational Foundations",
    body:
      "B.Com Graduate — 7.14 CGPI. 10th & 12th scored 82%+. 11 months of hands-on Finance Operations internship experience.",
    ctaLabel: null,
    ctaHref: null,
    meta: ["B.COM", "7.14 CGPI", "11 MO. INTERN"],
  },
];

export const socialButtons = [
  { id: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/in/manthandhotre/" },
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/manthandhotre17/" },
  { id: "substack", label: "Substack", href: "https://snippetofstartups.substack.com/" },
  { id: "email", label: "Email", href: "mailto:manthandhotre17@gmail.com" },
];

// Mock submit for the Connect form – stores locally until backend is wired.
export function submitConnectMock(payload) {
  return new Promise((resolve) => {
    setTimeout(() => {
      const existing = JSON.parse(localStorage.getItem("connect_submissions") || "[]");
      const entry = { ...payload, id: Date.now(), submittedAt: new Date().toISOString() };
      existing.push(entry);
      localStorage.setItem("connect_submissions", JSON.stringify(existing));
      resolve({ success: true, entry });
    }, 600);
  });
}
